import { useRef } from 'react';
import ReactJoyride, { type CallBackProps, type StoreHelpers } from 'react-joyride';

import GlobalFilterTooltipComponent from './GlobalFilterTooltipComponent';
import { SIDEBAR_LOCAL_STORAGE_JOYRIDE_KEY, type SidebarLocalStorageJoyride } from './SidebarLocalStorageJoyride';

import { useLocalStorage } from '@cobliteam/hooks';

export interface SidebarJoyrideProps {
  stepTargets: string[];
}

export const SidebarJoyride = ({ stepTargets }: SidebarJoyrideProps) => {
  const [localStorage, setLocalStorage] = useLocalStorage<SidebarLocalStorageJoyride>(SIDEBAR_LOCAL_STORAGE_JOYRIDE_KEY);

  const helpersRef = useRef<StoreHelpers | null>(null);
  const handleGetHelpers = (helpers: StoreHelpers) => {
    helpersRef.current = helpers;
  };

  const closeFloater = () => {
    helpersRef.current?.close();
  };

  const handleJoyrideCallback = (data: CallBackProps) => {
    const { index } = data;
    if (index + 1 === totalSteps) {
      setLocalStorage({
        ...localStorage,
        alreadyShowSidebarJoyride: true,
      });
    }
  };

  const totalSteps = stepTargets.length;

  const steps = [
    {
      content: <GlobalFilterTooltipComponent stepIndex={1} totalSteps={totalSteps} closeFloater={closeFloater} />,
      target: stepTargets[0],
      placement: 'right' as const,
      disableBeacon: true,
      hideFooter: true,
      hideCloseButton: true,
    },
  ];

  return (
    <ReactJoyride
      steps={steps}
      disableScrollParentFix
      getHelpers={handleGetHelpers}
      callback={handleJoyrideCallback}
      styles={{
        options: {
          width: 'fit-content',
        },
      }}
    />
  );
};
